import { render, staticRenderFns } from "./WatchButton.vue?vue&type=template&id=0547a1f6&"
import script from "./WatchButton.vue?vue&type=script&lang=js&"
export * from "./WatchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0547a1f6')) {
      api.createRecord('0547a1f6', component.options)
    } else {
      api.reload('0547a1f6', component.options)
    }
    module.hot.accept("./WatchButton.vue?vue&type=template&id=0547a1f6&", function () {
      api.rerender('0547a1f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/vendor/WatchButton.vue"
export default component.exports